function observeClassChanges(node, classNameToCheck) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const html = document.querySelector('body')
        console.log({NODEEEEEE: node})
        if (node.classList.contains(classNameToCheck)) {
          if (!html.classList.contains('product-sticky-active')) html.classList.add('product-sticky-active')
        } else {
          if (html.classList.contains('product-sticky-active')) html.classList.remove('product-sticky-active')
        }
      }
    }
  });

  observer.observe(node, {
    attributes: true,
    attributeFilter: ['class']
  });

  return observer;
}

const node = document.querySelector('.sticky-add-to-cart')
const classNameToCheck = 'active';
observeClassChanges(node, classNameToCheck);
